




































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import getUrlParam from '@/common/utils/getUrlParam';
import getActivityType from '@/common/utils/getActivityType';
import { IntroItem } from "@/common/interface";
import { replaceString } from '@/common/utils/dealWithString';
import fetch from "@/common/api/fetch";
const loadingImage = require("@/assets/img/loadingImage.gif");

interface numberSection {
  backgroundColor?: string;
  numberColor?: string;
  textColor?: string;
  borderColor?: string;
  showBorder?: boolean;
  borderRadius: number;
  borderWidth:number
}
interface section {
  textColor?: string;
}

@Component
export default class IndexRuleIntro extends Vue {
  
  @Getter("section") section!: section;
  @Getter("numberSection") numberSection!: numberSection;
  @Getter("limitNum") limitNum!: number;
  @Getter("isLimited") isLimited!: boolean;
  @Getter("joinNumber") joinNumber!: number;
  @Getter("leftQuota") leftQuota!: number;
  @Getter("showJoinFooter") showJoinFooter!: number;
  @Getter("showNum") showNum!: boolean;

  @Getter("activityRule") getterActivityRule!: string;
  @Getter("activityIntros") getterActivityIntros!: Array<IntroItem>;
  
  type: string = getUrlParam("type") as string;
  getActivityType: Function = getActivityType;
  loadingImage: string = loadingImage;

  get activityRule(): string {
    return replaceString(this.getterActivityRule);
  }

  get activityIntros(): Array<IntroItem> {
    const tempArray: Array<IntroItem> = [];
    for (let i: number = 0, length: number = this.getterActivityIntros.length;i < length;i++) {
      const item: IntroItem = Object.assign({},this.getterActivityIntros[i]);
      item.value = item.value && replaceString(item.value);
      tempArray.push(item);
    }
    return tempArray;
  }

  handleVideo(item: any) {
    fetch.parseUrl(item.value).then((res: any) => {
      const query = {
        url: res || item.value
      };
      this.$router.push({
        name: "video",
        query: query
      });
    });
  }
}

